import React from 'react'
import { Container } from "react-bootstrap";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import "./Footer.css"

const Footer = () => {

    const openInNewTab = (url) => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const link1 = "https://www.linkedin.com/in/aelohim/";
    const link2 = "https://github.com/aeloh1m";
    const link3 = "mailto:agraizzarodev@gmail.com";

    return (
        <div>

            <footer>
                <div className="footer-container">
                    <Container fluid className='logos-contact-f'>
                        <ul class="logos-ul-f">
                            <li className='logos-li-f'>
                                <FaLinkedin onClick={() => openInNewTab(link1)} ></FaLinkedin>

                            </li>
                            <li className='logos-li-f'>
                                <FaGithub onClick={() => openInNewTab(link2)} ></FaGithub>

                            </li>
                            <li className='logos-li-f'>
                                <div>

                                    <SiGmail onClick={() => openInNewTab(link3)} ></SiGmail>

                                </div>

                            </li>

                        </ul>

                    </Container>
                    <p className='p-container'>Rosario, Santa Fe, Argentina.</p>
                    <p className='p-container'>&copy; 2023 Aelohim</p>
                </div>
            </footer>
        </div>
    )
}

export default Footer